export default {"src":"/_next/static/media/chevron-right-gray.26714b05.svg","height":18,"width":12,"blurWidth":0,"blurHeight":0};